<template>
    <div style="height: calc(100vh - 45px); overflow: scroll;padding:0px 10px;">
      <!-- 班级选择器卡片 -->
      <div class="class-selector glass-panel" @click="openClassPicker">
        <div class="selector-content">
          <span class="label">当前班级</span>
          <div class="value">
            {{ searchObj.classNameAll || '点击选择班级' }}
            <van-icon name="arrow-down" size="12" />
          </div>
        </div>
      </div>

      <!-- 班级选择器弹窗 (年级快捷胶囊栏 + 班级滚轮) -->
      <van-popup v-model="classShowPicker" round position="bottom" class="glass-popup" @close="onCancelPicker">
        <div class="popup-header">
          <div class="btn cancel" @click="onCancelPicker">取消</div>
          <div class="title">选择班级</div>
          <div class="btn confirm" @click="onConfirmPicker">确定</div>
        </div>

        <!-- 年级快捷胶囊栏 -->
        <div v-if="gradeList && gradeList.length > 1" class="grade-capsule-bar">
          <div class="grade-scroll-wrap">
            <div 
              v-for="grade in gradeList" 
              :key="grade.code"
              class="grade-pill"
              :class="{ active: tempGrade === grade.code }"
              @click="handleGradePillClick(grade.code)"
            >
              <span class="grade-name">{{ grade.name }}</span>
              <span class="grade-count">({{ grade.count }})</span>
            </div>
          </div>
        </div>

        <van-picker 
          ref="classPicker" 
          :columns="filteredClassList" 
          :default-index="currentClassIndex" 
          :show-toolbar="false" 
          item-height="44" 
        />
      </van-popup>

      <el-table
        height="100%"
        :data="dataList"
        size='medium'
        border
        stripe
        style="width: 100%">
        <el-table-column
          type="index"
          fixed
          label="序号"
          align="center"
          width="60">
        </el-table-column>
        <el-table-column
          prop="studentName"
          fixed
          label="姓名"
          align="center"
          width="80">
        </el-table-column>
        <el-table-column
          width="140"
          prop="snCode"
          align="center"
          label="学号"
        >
        </el-table-column>
        <el-table-column
          prop="sex"
          align="center"
          label="性别"
          width="60">
        </el-table-column>
        <el-table-column prop="weightLevel" align="center" label="综合评定" width="80">
          <template slot-scope="scope">
            <span :style="`color:${weightLevelColor[scope.row.weightLevel]}`">{{scope.row.weightLevel}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="isFinish" align="center" label="测试状态" width="80">
          <template slot-scope="scope">
            {{isFinishMap[+scope.row.isFinish]}}
          </template>
        </el-table-column>
        <el-table-column prop="Height" align="center" label="身高(cm)" width="80"></el-table-column>
        <el-table-column prop="Weight" align="center" label="体重(kg)" width="80">
          <template slot-scope="scope">
            <a style="text-decoration: underline;">
              <span v-if="scope.row.Weight&&scope.row.Weight!==''">{{scope.row.Weight }}</span>
              <span v-else style="color:#aaa6a6;">无</span>
            </a>
          </template>
        </el-table-column>
        <el-table-column prop="SitAndReach" align="center" label="坐位体前屈" width="90">
          <template slot-scope="scope">
            <a style="text-decoration: underline;">
              <span v-if="scope.row.SitAndReach&&scope.row.SitAndReach!==''">{{scope.row.SitAndReach }}</span>
              <span v-else style="color:#aaa6a6;">无</span>
            </a>
          </template>
        </el-table-column>
        <el-table-column prop="RopeSkipping" align="center" label="跳绳(个)" width="80">
          <template slot-scope="scope">
            <a style="text-decoration: underline;">
              <span v-if="scope.row.RopeSkipping&&scope.row.RopeSkipping!==''">{{scope.row.RopeSkipping }}</span>
              <span v-else style="color:#aaa6a6;">无</span>
            </a>
          </template>
        </el-table-column>
        <el-table-column prop="VitalCapacity" align="center" label="肺活量(ml)" width="90">
          <template slot-scope="scope">
            <a style="text-decoration: underline;">
              <span v-if="scope.row.VitalCapacity&&scope.row.VitalCapacity!==''">{{scope.row.VitalCapacity }}</span>
              <span v-else style="color:#aaa6a6;">无</span>
            </a>
          </template>
        </el-table-column>
        <el-table-column prop="FiftyMeters" align="center" label="50米跑(秒)" width="80">
          <template slot-scope="scope">
            <a style="text-decoration: underline;">
              <span v-if="scope.row.FiftyMeters&&scope.row.FiftyMeters!==''">{{scope.row.FiftyMeters }}</span>
              <span v-else style="color:#aaa6a6;">无</span>
            </a>
          </template>
        </el-table-column>
        <el-table-column prop="SitUp" align="center" label="仰卧起坐(个)" width="80">
          <template slot-scope="scope">
            <a style="text-decoration: underline;">
              <span v-if="scope.row.SitUp&&scope.row.SitUp!==''">{{scope.row.SitUp }}</span>
              <span v-else style="color:#aaa6a6;">无</span>
            </a>
          </template>
        </el-table-column>
        <el-table-column prop="RunBack" align="center" label="50米*8(分秒)" width="80">
          <template slot-scope="scope">
            <a style="text-decoration: underline;">
              <span v-if="scope.row.RunBack&&scope.row.RunBack!==''">{{scope.row.RunBack }}</span>
              <span v-else style="color:#aaa6a6;">无</span>
            </a>
          </template>
        </el-table-column>
        <el-table-column prop="Jump" align="center" label="立定跳远(cm)" width="80">
          <template slot-scope="scope">
            <a style="text-decoration: underline;">
              <span v-if="scope.row.Jump&&scope.row.Jump!==''">{{scope.row.Jump }}</span>
              <span v-else style="color:#aaa6a6;">无</span>
            </a>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </template>
  
  <script>
  import { getClassInfoList, smallStudentScore } from "@/api/whitePage/teacherScore.js";
  import { setSession, getSession, removeSession } from "@/utils/cookie";

  export default {
    data() {
      return {
        isFinishMap: ['未完成', '已完成'],
        weightLevelColor: {
          优秀: '#4B7902',
          良好: '#F59A23',
          及格: '#8080FF',
          不及格: '#A30014',
        },
        dropdownValue: '',
        dropdownOption: [ 
          { text: '全部', value: '' },
          { text: '引体向上', value: 'PullUp' },
          { text: '立定跳远', value: 'Jump' },
          { text: '坐位体前屈', value: 'SitAndReach' },
          { text: '仰卧起坐', value: 'SitUp' },
          { text: '体重/身高', value: 'HeightWeight' },
          { text: '肺活量', value: 'VitalCapacity' },
          { text: '双杠臂屈伸', value: 'TricepsDip' },
          { text: '纵跳摸高', value: 'TricepsDip' },
        ],
        searchShow: false,
        searchStr: "",

        tabList: [
          { name: "待审核", value: "0" },
          { name: "通过", value: "2" },
          { name: "驳回", value: "3" },
        ],
        dataList: [],
        pageIndex: 1,
        pageSize: 10,
        loading: false,
        finished: false,
        wfType: "0",
        reqType: null,
        allClassList: [],
        classShowPicker: false,
        tempGrade: 'ALL',
        searchObj: {
          classNameAll: '',
          classCode: '',
          className: '',
          gradeCode: '',
          gradeName: '',
          studentName: '',
          selectedGrade: 'ALL'
        }
      };
    },
    computed: {
      gradeList() {
        if (!this.allClassList || this.allClassList.length === 0) return [];
        const map = new Map();
        this.allClassList.forEach(item => {
          const key = item.gradeKey;
          const name = item.gradeName || '未分年级';
          if (!map.has(key)) {
            map.set(key, { code: key, name: name, count: 0 });
          }
          map.get(key).count++;
        });
        return [
          { code: 'ALL', name: '全部年级', count: this.allClassList.length },
          ...Array.from(map.values())
        ];
      },
      filteredClassList() {
        if (!this.tempGrade || this.tempGrade === 'ALL') {
          return this.allClassList;
        }
        return this.allClassList.filter(item => item.gradeKey === this.tempGrade);
      },
      currentClassIndex() {
        if (!this.searchObj.classCode || !this.filteredClassList.length) return 0;
        let idx = this.filteredClassList.findIndex(item => 
          item.value === this.searchObj.classCode && 
          (!this.searchObj.className || item.className === this.searchObj.className || item.text === this.searchObj.className)
        );
        if (idx < 0) {
          idx = this.filteredClassList.findIndex(item => item.value === this.searchObj.classCode);
        }
        return idx >= 0 ? idx : 0;
      }
    },
    beforeRouteLeave(to, from, next) {
      if (!to || !to.path || (to.path.indexOf('/fitnessReport') === -1 && to.path.indexOf('/bodyForging') === -1)) {
        removeSession('whitePage/teacherScore');
      }
      next();
    },
    filters: {
      stateFil(val) {
        const obj = {
          "1": "待审核",
          "2": "审核通过",
          "3": "审核驳回",
          "4": "作废",
        };
        if (val) {
          return obj[val];
        } else {
          return "待提交";
        }
      },
      appealTypeFil(val) {
        const obj = {
          "1": "未识别人脸",
          "2": "未经过点位",
          "3": "未检录",
        };
        if (val) {
          return obj[val];
        } else {
          return "";
        }
      },
    },
    created() {
      this.loading = true;
      this.finished = false;
      this.pageIndex = 1;
      this.pageSize = 10;
      this.setupList = [];
      this.init();
      const cache = getSession('whitePage/teacherScore');
      if (cache) {
        try {
          const cachedObj = JSON.parse(cache);
          this.searchObj = Object.assign({}, this.searchObj, cachedObj);
        } catch (e) {}
        if (!this.searchObj.selectedGrade) {
          this.searchObj.selectedGrade = 'ALL';
        }
        if (this.searchObj.classCode) {
          this.getList();
        }
      }
    },
    methods: {
      onSeeReport(item) {
        let data = JSON.stringify({
          snCode: item.snCode,
          schoolCode: item.schoolCode,
          termCode: item.termCode,
          teacher: true
        });
        this.$router.push({ path: '/fitnessReport', query: { data: data } });
      },
      onbodyReport(item) {
        let data = JSON.stringify({
          snCode: item.snCode,
          schoolCode: item.schoolCode,
          termCode: item.termCode,
          teacher: true
        });
        this.$router.push({ path: '/bodyForging', query: { data: data } });
      },
      goInfo(row) {
        this.$router.push({ path: 'teacherReporting/reportingList', query: { snCode: row.snCode, schoolCode: row.schoolCode } });
      },
      openClassPicker() {
        this.tempGrade = this.searchObj.selectedGrade || 'ALL';
        this.classShowPicker = true;
        this.$nextTick(() => {
          this.$nextTick(() => {
            if (this.$refs.classPicker && typeof this.$refs.classPicker.setColumnIndex === 'function') {
              this.$refs.classPicker.setColumnIndex(0, this.currentClassIndex);
            }
          });
        });
      },
      handleGradePillClick(gradeCode) {
        if (this.tempGrade === gradeCode) return;
        this.tempGrade = gradeCode;
        this.$nextTick(() => {
          this.$nextTick(() => {
            if (this.$refs.classPicker && typeof this.$refs.classPicker.setColumnIndex === 'function') {
              let targetIdx = 0;
              if (this.searchObj.classCode) {
                const foundIdx = this.filteredClassList.findIndex(item => item.value === this.searchObj.classCode);
                if (foundIdx >= 0) {
                  targetIdx = foundIdx;
                }
              }
              this.$refs.classPicker.setColumnIndex(0, targetIdx);
            }
          });
        });
      },
      onCancelPicker() {
        this.classShowPicker = false;
        this.tempGrade = this.searchObj.selectedGrade || 'ALL';
      },
      onConfirmPicker() {
        if (this.$refs.classPicker) {
          if (typeof this.$refs.classPicker.confirm === 'function') {
            this.$refs.classPicker.confirm();
          }
          let val = null;
          if (typeof this.$refs.classPicker.getValues === 'function') {
            const vals = this.$refs.classPicker.getValues();
            val = vals && vals[0];
          }
          if (!val && typeof this.$refs.classPicker.getColumnIndex === 'function') {
            const cIdx = this.$refs.classPicker.getColumnIndex(0);
            val = this.filteredClassList[cIdx];
          }
          if (!val && this.filteredClassList.length > 0) {
            val = this.filteredClassList[0];
          }
          if (val) {
            this.searchObj.selectedGrade = this.tempGrade || 'ALL';
            this.searchObj.classCode = val.value;
            this.searchObj.classNameAll = val.text;
            this.searchObj.className = val.className;
            this.searchObj.gradeCode = val.gradeCode;
            this.searchObj.gradeName = val.gradeName;
            this.getList();
            this.classShowPicker = false;
            setSession('whitePage/teacherScore', JSON.stringify(this.searchObj));
            return;
          }
        }
        this.classShowPicker = false;
      },
      init() {
        getClassInfoList({
          teacherId: this.$route.query.teacherId || '',
          schoolCode: this.$route.query.schoolCode || '',
        }).then(res => {
          const rawList = (res && res.data && res.data.data) || [];
          const seen = new Set();
          const uniqueList = [];
          rawList.forEach(item => {
            if (item && item.classCode) {
              const text = `${(item.gradeName || '').trim()}-${(item.className || '').trim()}`.trim() || item.className;
              const key = `${item.classCode}_${text}`;
              if (!seen.has(key)) {
                seen.add(key);
                uniqueList.push({
                  text: text,
                  className: item.className,
                  value: item.classCode,
                  gradeCode: item.gradeCode,
                  gradeName: (item.gradeName || '').trim(),
                  gradeKey: String(item.gradeCode || item.gradeName || 'other')
                });
              }
            }
          });
          this.allClassList = uniqueList;
        }).catch(() => {});
      },
      getList() {
        smallStudentScore({
          teacherId: this.$route.query.teacherId || '',
          schoolCode: this.$route.query.schoolCode || '',
          classCode: this.searchObj.classCode,
          className: this.searchObj.className,
          studentName: this.searchObj.studentName,
          grade: this.searchObj.gradeCode,
          gradeName: this.searchObj.gradeName,
          pageSize: 999,
          current: 1
        }).then(res => {
          res.data.body?.list?.forEach(el => {
            el?.scoreList.forEach(dl => {
              el[dl.projectCode] = dl.score;
            });
          });
          this.dataList = (res.data.body && res.data.body.list) || [];
        }).catch(() => {});
      },
      onStatus(e) {
        this.loading = true;
        this.finished = false;
        this.pageIndex = 1;
        this.pageSize = 10;
        this.dataList = [];
        this.wfType = e;
        this.onLoad();
      },
      dropdownChange() {
        this.loading = true;
        this.finished = false;
        this.pageIndex = 1;
        this.pageSize = 10;
        this.dataList = [];
        this.onLoad();
      },
      openInfo(dataId) {
        this.$router.push({
          name: "indoorAuditInfo",
          query: { dataId: dataId, wfType: this.wfType, runType: this.$route.query.runType },
        });
      },
    },
  };
  </script>
  
  <style lang="less" scoped>
  /* 班级选择器卡片 */
  .class-selector {
    margin: 8px 0 10px;
  }
  .glass-panel {
    background: rgba(255, 255, 255, 0.9);
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    padding: 12px 16px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
    cursor: pointer;
    
    &:active { opacity: 0.8; transform: scale(0.99); transition: all 0.2s; }

    .selector-content {
      display: flex; justify-content: space-between; align-items: center;
      .label { font-size: 14px; color: #8e8e93; }
      .value { font-size: 15px; font-weight: 600; color: #007AFF; display: flex; align-items: center; gap: 4px; }
    }
  }

  /* 底部弹窗 */
  .glass-popup { background: #f2f2f7; }
  .popup-header {
    display: flex; justify-content: space-between; align-items: center; padding: 12px 16px; background: #fff;
    .btn { font-size: 15px; cursor: pointer; }
    .cancel { color: #8e8e93; }
    .confirm { color: #007AFF; font-weight: 600; }
    .title { font-weight: 600; font-size: 16px; }
  }

  /* 年级快捷胶囊栏 */
  .grade-capsule-bar {
    padding: 10px 16px 8px;
    background: #fff;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);

    .grade-scroll-wrap {
      display: flex;
      overflow-x: auto;
      gap: 8px;
      padding-bottom: 2px;
      
      /* 隐藏滚动条 */
      &::-webkit-scrollbar { display: none; width: 0; height: 0; }
      -ms-overflow-style: none;
      scrollbar-width: none;
    }

    .grade-pill {
      flex-shrink: 0;
      padding: 6px 14px;
      border-radius: 16px;
      font-size: 13px;
      background: rgba(118, 118, 128, 0.08);
      color: #636366;
      display: flex;
      align-items: center;
      gap: 4px;
      cursor: pointer;
      transition: all 0.25s cubic-bezier(0.25, 0.8, 0.25, 1);
      font-weight: 500;

      .grade-count {
        font-size: 11px;
        opacity: 0.75;
      }

      &.active {
        background: #007AFF;
        color: #fff;
        font-weight: 600;
        box-shadow: 0 2px 8px rgba(0, 122, 255, 0.3);

        .grade-count {
          opacity: 0.9;
        }
      }

      &:active {
        transform: scale(0.96);
      }
    }
  }

  .boxlist{
    padding: 6px;
    margin: 6px;
    border: 1px solid #ccc;
    border-radius: 10px;
    background-color: #fff;
    font-size: 14px;
    color: #323233;
    line-height: 24px;
    box-shadow: inset calc(-1px * var(--dir-factor)) 0 0 rgba(0, 0, 0, 0.25);
  }
  ::v-deep .van-cell__label{
    color: #1a1a1a;
  }
  </style>
